export const FETCH_CONTINENTS = 'FETCH_CONTINENTS';
export const FETCH_ALL_TIME_DATA = 'FETCH_ALL_TIME_DATA';
